"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFExport = void 0;
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const reports_1 = require("shared/reports");
require("./pdf-export.less");
const mobx_1 = require("mobx");
const store_2 = require("client/modules/users/store");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const kpi_header_1 = require("client/components/kpi-header");
const floating_page_1 = require("client/components/page/floating-page");
const list_1 = require("client/components/material/list");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const moment = require("moment");
const modal_1 = require("client/components/modal");
const text_field_1 = require("client/components/material/text-field");
const columns = [
    {
        id: "report.reportName",
        label: "File Name"
    },
    {
        id: "report.reportName",
        label: "Date Created"
    },
    {
        id: "report.reportName",
        label: "Expires"
    },
    {
        id: "report.reportName",
        label: "Download"
    }
];
const dummyQuery = {
    email: "",
    end: new Date(),
    site: "",
    start: new Date()
};
let PDFExport = class PDFExport extends React.Component {
    constructor() {
        super(...arguments);
        this.files = [];
        this.showModal = false;
        this.query = dummyQuery;
        this.loadPdfs = async () => {
            this.files = await store_1.reportsStore.loadPdfZips();
        };
        this.handleSubmit = async () => {
            this.showModal = false;
            await store_1.reportsStore.generatePdfZips(this.query);
            await this.loadPdfs();
        };
        this.newExportModal = () => {
            const modalButtons = [
                React.createElement(button_1.MaterialButton, { onClick: () => {
                        this.query = dummyQuery;
                        this.showModal = false;
                    } }, "Cancel"),
                React.createElement(button_1.MaterialButton, { onClick: async () => this.handleSubmit(), primary: true, style: { marginLeft: "1em" }, disabled: !this.query.site || !this.query.start || !this.query.end }, "Generate Export")
            ];
            return (React.createElement(modal_1.Modal, { buttons: modalButtons, onCancel: () => {
                    this.showModal = false;
                }, top: "25%", width: "26em" },
                React.createElement(select_1.MaterialSelect, { label: "Pharmacy", options: this.availableOptions, onSelect: e => {
                        this.query.site = e;
                    }, searchable // C-119
                    : true, required: true, value: String(this.query.site) }),
                React.createElement("div", null,
                    React.createElement(date_picker_1.MaterialDatePicker, { label: "Start Date", disableFuture: true, onChange: e => {
                            this.query.start = e;
                        }, required: true, value: String(this.query.start) }),
                    React.createElement(date_picker_1.MaterialDatePicker, { label: "End Date", required: true, disableFuture: true, onChange: e => {
                            this.query.end = e;
                        }, value: String(this.query.end) }),
                    React.createElement(text_field_1.MaterialTextField, { label: "Confirmation Email", onChange: (e, v) => {
                            this.query.email = v;
                        }, value: String(this.query.email) }))));
        };
        this.renderList = () => (React.createElement("div", { className: "pdfexport" },
            React.createElement(list_1.MaterialList, { columns: columns, 
                // onRequestSort={this.onRequestSort}
                order: "ASC", 
                // orderBy={this.orderBy}
                rows: this.files, renderRow: this.renderListRow })));
        this.renderListRow = (row, index) => {
            if (!row.location)
                return; // Dead file; legacy safety.
            return (React.createElement("div", { style: {
                    alignItems: "center",
                    display: "flex",
                    flex: "inherit",
                    justifyContent: "space-around",
                    padding: ".5em"
                } },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.name }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: moment(row.date).format("MM/DD/YY") }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: moment(row.date)
                        .add(2, "weeks")
                        .format("MM/DD/YY") }),
                React.createElement(button_1.MaterialButton, { onClick: () => window.open(`/exports/${row.location}.zip`, "_blank"), disabled: row.status !== reports_1.QueueStatus.complete }, row.status === reports_1.QueueStatus.complete ? "Download" : "Generating")));
        };
    }
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_2.usersStore.user.value.user;
        if (isImbUser) {
            if (store_3.sitesListStore.sites.value) {
                // options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_3.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_2.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    async componentDidMount() {
        const [ms, seconds] = [1000, 5];
        await this.loadPdfs();
        this.intervalLoadPdfs = setInterval(async () => this.loadPdfs(), // ?
        ms * seconds);
    }
    componentWillUnmount() {
        clearInterval(this.intervalLoadPdfs);
    }
    render() {
        return (React.createElement("div", null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } },
                    React.createElement(kpi_title_1.KpiTitle, { label: "PDF Export" }),
                    React.createElement(button_1.MaterialButton, { primary: true, style: { whiteSpace: "nowrap", width: "12em" }, onClick: () => {
                            this.showModal = true;
                        } }, "New Export"))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "floating-page" }, this.renderList()),
                this.showModal && this.newExportModal())));
    }
};
__decorate([
    mobx_1.observable
], PDFExport.prototype, "files", void 0);
__decorate([
    mobx_1.observable
], PDFExport.prototype, "showModal", void 0);
__decorate([
    mobx_1.observable
], PDFExport.prototype, "query", void 0);
__decorate([
    mobx_1.computed
], PDFExport.prototype, "availableOptions", null);
PDFExport = __decorate([
    mobx_react_1.observer
], PDFExport);
exports.PDFExport = PDFExport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/pdf-export/pdf-export.tsx
// module id = 3949
// module chunks = 0